import React from 'react';
import { Plus } from 'lucide-react';

interface DesktopChatEmptyStateProps {
  onCreateGroup?: () => void;
  /** 'activity' = 알림 탭의 오른쪽 자리 — 누른 알림의 대화가 열리는 곳이라 문구가 다르고 개설 버튼이 없다 */
  variant?: 'chat' | 'activity';
}

/**
 * 데스크톱 3컬럼에서 오른쪽에 열린 대화방이 없을 때(X로 닫음·알림/온라인 탭·대화방 0개).
 * 홈 탭은 rail + 홈 한 칸(넓은 홈)이라 여기를 거치지 않고, 대화방 탭은 들어올 때 마지막 대화를 다시 열므로
 * 이 화면은 사용자가 직접 닫았을 때 주로 보인다 — 그래서 대시보드가 아니라 가벼운 안내 한 장이다.
 * 알림 탭은 들어올 때 채팅을 닫으므로(handleDesktopTabChange) 그 탭에서는 늘 이 화면부터 보인다.
 * 버튼은 아웃라인: 채움(brand-600)은 화면의 주 액션 자리인데 여기는 '고르기'가 먼저다.
 */
export const DesktopChatEmptyState: React.FC<DesktopChatEmptyStateProps> = React.memo(({ onCreateGroup, variant = 'chat' }) => (
  <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
    <img src="/icon.png" alt="" className="w-14 h-14 rounded-2xl opacity-90" />
    <p className="mt-4 text-base font-bold text-slate-700">
      {variant === 'activity' ? '선택한 알림이 없습니다' : '열려 있는 대화방이 없습니다'}
    </p>
    <p className="mt-1.5 text-sm text-slate-500">
      {variant === 'activity' ? '왼쪽 알림을 누르면 그 대화가 여기에 열립니다' : '왼쪽 목록에서 대화방을 골라 보세요'}
    </p>
    {onCreateGroup && variant !== 'activity' && (
      <button
        type="button"
        onClick={onCreateGroup}
        className="mt-5 h-10 pl-3 pr-4 rounded-xl border border-slate-300 bg-white text-sm font-semibold text-slate-700 hover:bg-slate-50 hover:border-slate-400 flex items-center gap-1.5 transition-colors"
      >
        <Plus size={18} aria-hidden="true" />
        대화방 개설
      </button>
    )}
  </div>
));
DesktopChatEmptyState.displayName = 'DesktopChatEmptyState';
